var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscover(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "true",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6772F",
    fillRule: "nonzero",
    d: "M2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0120.01 20H3.99A1.994 1.994 0 012 18.006V5.994z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M4 6v12h16V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6772F",
    d: "M4 20h13.827a3.507 3.507 0 003.508-3.5V13S15.213 17.836 4 20z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M6.483 9.108H5v4.777h1.474c.784 0 1.35-.173 1.846-.553.59-.45.94-1.13.94-1.835 0-1.41-1.142-2.39-2.777-2.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M7.663 12.695c-.321.265-.73.38-1.383.38h-.27V9.917h.27c.653 0 1.046.108 1.383.386.347.287.556.73.556 1.188 0 .46-.21.919-.556 1.204z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M9.725 9.108h1.005v4.777H9.725zm3.474 1.831c-.607-.206-.784-.343-.784-.6 0-.3.317-.529.752-.529.303 0 .551.112.817.385l.524-.636a2.363 2.363 0 00-1.518-.53c-.916 0-1.614.587-1.614 1.365 0 .66.325.995 1.272 1.313.395.127.596.214.698.273.202.12.302.293.302.492 0 .389-.333.674-.784.674-.48 0-.868-.221-1.1-.638l-.65.582c.464.629 1.022.91 1.79.91 1.047 0 1.785-.647 1.785-1.57 0-.76-.342-1.104-1.49-1.491m1.807.558c0 1.405 1.194 2.494 2.731 2.494.434 0 .805-.08 1.263-.279v-1.097c-.404.375-.76.523-1.218.523-1.016 0-1.736-.679-1.736-1.647 0-.915.743-1.64 1.691-1.64.479 0 .844.157 1.263.537V9.292C18.558 9.086 18.195 9 17.758 9c-1.528 0-2.752 1.11-2.752 2.497"
  }))));
}

export default SvgDiscover;